/** The live co-browsing screen. */
const en = {
  title: 'Live',
  online: (n: number) => `${n} online`,
  connecting: 'connecting…',
  watching: 'Watching',
  allProjects: 'All projects',
  onlineSuffix: (n: number) => `· ${n} online`,
  unknownProject: 'Unknown project',
  activeVisitors: 'Active visitors',
  noVisitors: 'No one is online right now. Open an SDK-instrumented page to see it here.',
  selectVisitor: 'Select a visitor to watch their screen and chat.',
  requestControl: 'Request control',
  controlDisabled:
    "Remote control isn't enabled for your account. Ask an admin in user management.",
  waitingConsent: 'Waiting for consent… (cancel)',
  stopControl: 'Stop control',
  controlling: 'controlling',
  live: 'live',
  noMessages: 'No messages yet. Say hello 👋',
  messagePlaceholder: 'Message this visitor…',
  devTools: 'Live DevTools · since you started watching',
  ended: (id: string, url: string) => `Session ${id} ended${url ? ` on ${url}` : ''}.`,
  openAsBug: 'Open as bug',
  watchReplay: 'Watch replay',
  issueTitle: (what: string) => `Live session issue, ${what}`,
  issueBody: (url: string) =>
    `Observed live and reported by the operator right after the session ended.\nLast URL: ${url}`,
};

const tr: typeof en = {
  title: 'Canlı',
  online: (n: number) => `${n} çevrimiçi`,
  connecting: 'bağlanıyor…',
  watching: 'İzlenen',
  allProjects: 'Tüm projeler',
  onlineSuffix: (n: number) => `· ${n} çevrimiçi`,
  unknownProject: 'Bilinmeyen proje',
  activeVisitors: 'Aktif ziyaretçiler',
  noVisitors:
    'Şu anda kimse çevrimiçi değil. SDK kurulu bir sayfayı açın, burada görünsün.',
  selectVisitor: 'Ekranını izlemek ve sohbet etmek için bir ziyaretçi seçin.',
  requestControl: 'Kontrol iste',
  controlDisabled:
    'Hesabınızda uzaktan kontrol açık değil. Kullanıcı yönetiminden bir yöneticiye sorun.',
  waitingConsent: 'Onay bekleniyor… (iptal)',
  stopControl: 'Kontrolü bırak',
  controlling: 'kontrol ediliyor',
  live: 'canlı',
  noMessages: 'Henüz mesaj yok. Selam verin 👋',
  messagePlaceholder: 'Bu ziyaretçiye mesaj yazın…',
  devTools: 'Canlı DevTools · izlemeye başladığınızdan beri',
  ended: (id: string, url: string) =>
    `${id} oturumu sona erdi${url ? ` (${url})` : ''}.`,
  openAsBug: 'Hata olarak aç',
  watchReplay: 'Kaydı izle',
  issueTitle: (what: string) => `Canlı oturum sorunu, ${what}`,
  issueBody: (url: string) =>
    `Canlı izlenirken, oturum biter bitmez operatör tarafından bildirildi.\nSon URL: ${url}`,
};

export const live = { en, tr };
